module.exports = __webpack_public_path__ + "avatar-placeholder.99cddaa7a1f28c8058b5f7067b0662c5.hashedasset.svg";